import angular from 'angular';
import uiRouter from 'angular-ui-router';
import auditprogressComponent from './auditprogress.component';

let auditprogressModule = angular.module('auditprogress', [
  uiRouter
])

.component('auditprogress', auditprogressComponent);

export default auditprogressModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/auditprogress/auditprogress.js